import { Button } from '@chakra-ui/react';
import { MaskIcon } from '@ui/components/MaskIcon';

import { useAgentsView } from './useAgentsView';

export const SearchInputToggle = () => {
  const isSearchInputShown = useAgentsView((s) => s.isSearchInputShown);

  const isActiveProps = isSearchInputShown
    ? {
        'data-active': true,
      }
    : null;

  return (
    <Button
      variant="icon"
      ml="auto"
      {...isActiveProps}
      onClick={() => {
        useAgentsView.setState({
          isSearchInputShown: !isSearchInputShown,
        });
      }}
    >
      <MaskIcon icon="url(/masks/search.svg)" />
    </Button>
  );
};
